import ahoy from "ahoy.js/dist/ahoy.esm"

declare global {
  interface Window { ahoy: typeof ahoy; }
}

window.ahoy = ahoy

ahoy.configure({
  cookies: false,
  visitsUrl: "/stellenanzeigen/visits",
  eventsUrl: "/stellenanzeigen/events",
  useBeacon: true,
})


let impressionQueue: Array<{ name: string; properties: any }> = []
let debounceTimer: NodeJS.Timeout | null = null

function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

async function sendBatchedImpressions() {
  if (impressionQueue.length === 0) return

  // Get CSRF token
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
  if (!csrfToken) {
    console.error('CSRF token not found')
    return
  }

  // Prepare events array with required format
  const events = impressionQueue.map(item => ({
    name: item.name,
    properties: item.properties,
    time: Date.now() / 1000, // Unix timestamp in seconds
    id: generateUUID(),
    js: true
  }))

  // Clear the queue
  impressionQueue = []

  try {
    const response = await fetch('/stellenanzeigen/events', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-Token': csrfToken
      },
      body: new URLSearchParams({
        events_json: JSON.stringify(events)
      })
    })

    if (!response.ok) {
      console.error('Failed to send impression events:', response.statusText)
    }
  } catch (error) {
    console.error('Error sending impression events:', error)
  }
}

export function trackImpression(name: string, properties: any = {}): void {
  impressionQueue.push({ name, properties })

  if (debounceTimer) {
    clearTimeout(debounceTimer)
  }

  debounceTimer = setTimeout(() => {
    sendBatchedImpressions()
    debounceTimer = null
  }, 500)
}

export default ahoy
